import React from 'react';

const ChartCard = ({ title, subtitle, children, isDark = false, className = '', action = null }) => {
  return (
    <div
      className={`rounded-2xl p-5 transition-all duration-200 ${className}`}
      style={{
        background: isDark ? '#0f1729' : '#ffffff',
        border: `1px solid ${isDark ? '#1e2d52' : '#e2e8f0'}`,
        boxShadow: isDark ? '0 1px 8px rgba(0,0,0,0.18)' : '0 1px 8px rgba(0,0,0,0.06)',
        overflow: 'hidden',   // ← prevents chart from bleeding outside card
        minWidth: 0,          // ← allows card to shrink properly inside CSS grid
      }}
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3
            className="text-sm font-semibold font-['Outfit']"
            style={{ color: isDark ? '#f0f6fc' : '#0f172a' }}
          >
            {title}
          </h3>
          {subtitle && (
            <p className="text-xs mt-0.5" style={{ color: isDark ? '#64748b' : '#94a3b8' }}>{subtitle}</p>
          )}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
      {children}
    </div>
  );
};

export default ChartCard;